import React from "react";

import { PrimaryButton } from "../../simple-buttons/simple-buttons";
import { SVGDeclineIcon } from "../../svg-animated/svg-animated";
import DocumentStatus from "./document-status";

const DocumentScanned = ({ resetJourney }: { resetJourney: () => Promise<void> }) => {
    return (
        <DocumentStatus
            icon={<SVGDeclineIcon />}
            headingText="Scanned document detected"
            subheadingText="It looks like you uploaded a scanned document."
            paragraphText="We do not accept scanned documents as proof of identity. You need to take a clear photo of your document and upload again."
            button={<PrimaryButton onClick={() => resetJourney()} text="Try again" />}
        />
    )
};

export default DocumentScanned;
